import { Form, Formik } from 'formik'
import React from 'react'
import { required } from '../utils/validators'
import Button from './common/Button'
import Input from './common/Input'

export default function NoteForm({ initialValues, onSubmit, loading, onCancel }) {
    return (
        <Formik initialValues={{ title: '', mark: '', price: '', ...initialValues }} onSubmit={onSubmit}>
            <Form>
                <Input
                    component="textarea"
                    label="Текст"
                    name="title"
                    disabled={loading}
                    placeholder="Введите имя кабинета"
                    validate={required} />
                <Input
                    label="Отметка"
                    name="mark"
                    disabled={loading}
                    placeholder="Введите имя кабинета"
                    validate={required} />
                <Input
                    label="Сумма штрафа"
                    name="price"
                    disabled={loading}
                    placeholder="Введите сумма штрафа"
                    validate={required} />

                <Button
                    loading={loading}
                    text="Сохранить"
                    type="submit"
                    icon="ion-md-checkmark"
                    className="is-success" /> &nbsp;

                <Button
                    onClick={onCancel}
                    icon="ion-md-close"
                    text="Отмена"
                    className="is-danger" />
            </Form>
        </Formik>
    )
}
